(ns kyber.interceptors.user-sub
  (:require [re-frame.core :as re-frame]))

(defn user-sub-interceptor
  [context]
  (assoc-in context [:coeffects :user-sub]
            (get-in context [:coeffects :db :session :user :sub])))

(def ^{:doc "Injects the user-sub boolean onto the coeffects map for ease of access within event handlers"}
  user-sub (re-frame/->interceptor :id :user-sub
                                   :before user-sub-interceptor))
